import React from 'react';

import {Navigate} from 'react-router-dom';
import {FeaturesEnum, HomeEnum} from 'presentation/constants';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {Communications} from '../..';
import {useCommunications} from '../../hooks/useCommunications';

export function CommunicationsLayout() {
	const {isHolder} = useAccountInformation();
	const {
		getCommunicationsQuery: {isError},
	} = useCommunications();
	const {isEnabled: communicationsFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_RN_585,
	);

	const cantAccessCommunicationsService =
		!isHolder || isError || communicationsFlagEnabled === false;

	if (cantAccessCommunicationsService) {
		return <Navigate to={HomeEnum.HOME_PAGE} />;
	}

	return <Communications />;
}
